import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';

let config = {
  apiKey: "AIzaSyC5nzMdIEXzWarHI2lKiRp-G48tLdL0sIU",
  authDomain: "crocobet-promotions.firebaseapp.com",
  databaseURL: "https://crocobet-promotions.firebaseio.com",
  projectId: "crocobet-promotions",
  storageBucket: "crocobet-promotions.appspot.com",
  messagingSenderId: "454715895510",
  appId: "1:454715895510:web:4bd75015e0833359"
};

class Firebase {

  constructor() {
    app.initializeApp(config);

    this.auth = app.auth();
    this.db = app.database();
    this.storage = app.storage();
  }
}

export default Firebase;
